import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

Vue.config.devtools = true;

import uxModule from "./Modules/uxModule";
import formFieldsModule from "./Modules/formFieldsModule";
import sharedModule from "./Modules/sharedModule";
import securityModule from "./Modules/securityModule";
import seitDocsModule from "./Modules/seitDocsModule";
import filesModule from "./Modules/filesModule";
const state = {};

const mutations = {};

const actions = {};

const store = new Vuex.Store({
  modules: {
    uxModule: uxModule,
    formFieldsModule: formFieldsModule,
    sharedModule: sharedModule,
    securityModule: securityModule,
    seitDocsModule: seitDocsModule,
    filesModule: filesModule,
  },

  state,
  mutations,
  actions,
  //plugins: [
  //  createPersistedState({
  //    storage: window.sessionStorage,
  //  }),
  //],
});

export default store;
